import { useCallback, useEffect, useState } from "react";
import { API } from "../auth/api";

export function useFirms() {
  const [firms, setFirms] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const { data } = await API.get("/firms");
      setFirms(Array.isArray(data) ? data : []);
    } catch (_e) {
      setFirms([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  const addFirm = useCallback(async (payload) => {
    const { data } = await API.post("/firms", payload);
    setFirms((prev) => [...prev, data]);
    return data;
  }, []);

  const updateFirm = useCallback(async (id, patch) => {
    const { data } = await API.put(`/firms/${id}`, patch);
    setFirms((prev) => prev.map((f) => (f.id === id ? data : f)));
    return data;
  }, []);

  const deleteFirm = useCallback(async (id) => {
    await API.delete(`/firms/${id}`);
    setFirms((prev) => prev.filter((f) => f.id !== id));
  }, []);

  return { firms, loading, addFirm, updateFirm, deleteFirm, reload: load };
}
